import { createSlice } from "@reduxjs/toolkit";

export interface FirmState {
    addFirmVisibility: boolean,
}

const initialState: FirmState = {
    addFirmVisibility: false,
};

export const firmSlice = createSlice({
    name: 'searchResult',
    initialState,
    reducers: {
        setFirmPopupVisibility: (state: FirmState, action) => {
            state.addFirmVisibility = action.payload;
        },
    }
})

export const { setFirmPopupVisibility } = firmSlice.actions;
export default firmSlice.reducer;